import { render, staticRenderFns } from "./estate-text-section.vue?vue&type=template&id=7cef1328&"
import script from "./estate-text-section.vue?vue&type=script&lang=js&"
export * from "./estate-text-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports